// extracted by mini-css-extract-plugin
export var cell = "_55-4";
export var headerCell = "_55-2";
export var rowHeader = "_55-3";
export var table = "_55-1";
export var tableContainer = "_55-0";